import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"#fff\" clip-path=\"url(#clip0_21777_121388)\"><path fill-opacity=\".8\" d=\"M10 17.576a5.65 5.65 0 0 0 2.828-4.898v-4.63h2.127c.534 0 .801-.669.424-1.06l-4.955-5.139A.59.59 0 0 0 10 1.667z\"></path><path fill-rule=\"evenodd\" d=\"M7.174 18.333c1.03 0 1.994-.275 2.826-.756V1.666a.59.59 0 0 0-.424.182L4.621 6.988c-.377.391-.11 1.06.424 1.06h2.129z\" clip-rule=\"evenodd\"></path></g><defs><clipPath id=\"clip0_21777_121388\"><path fill=\"#fff\" d=\"M4.444 18.333h11.111V1.666H4.445z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }